export default __webpack_public_path__ + "static/media/Instagram-clone.b677b742.png";